module.exports = __webpack_public_path__ + "media/images/battery-80-0b03b427192a3c6000a634715255ba48.png";